import { useState } from 'react';

import { Secrets } from './interfaces';

export const useNewSecrets = () => {
  const [clientId, setClientId] = useState<string>();
  const [clientSecret, setClientSecret] = useState<string>();

  const handleNewSecrets = (secrets: Secrets) => {
    setClientId(secrets.clientId);
    setClientSecret(secrets.clientSecret);
  };

  return { clientId, clientSecret, handleNewSecrets };
};
